import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".login-info-container ::placeholder{font-style:normal!important}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
